module.exports = __webpack_public_path__ + "prod/1.42.2/img/bg-dialog-success.76fc2998.png";